import type { Course, Problem, Solution, Value, Audience } from "./types";

export const courses: Course[] = [
  {
    id: "1",
    title: "Lập Trình Nền Tảng",
    description:
      "Nền tảng vững chắc với JavaScript, Python, Git và tư duy thuật toán. Từ zero đến hero trong 3 tháng.",
    icon: "ri-code-s-slash-line",
    color: "from-blue-500 to-cyan-500",
    topics: [
      "JavaScript",
      "Python",
      "Git & GitHub",
      "Algorithms & Data Structures",
    ],
  },
  {
    id: "2",
    title: "Phát Triển Phần Mềm",
    description:
      "Xây dựng ứng dụng web và mobile hoàn chỉnh. Frontend, Backend, Database và triển khai thực tế.",
    icon: "ri-window-line",
    color: "from-green-500 to-emerald-500",
    topics: [
      "React & Next.js",
      "Node.js & Express",
      "Database Design",
      "API Development",
    ],
  },
  {
    id: "3",
    title: "Trí Tuệ Nhân Tạo",
    description:
      "Khám phá AI, Machine Learning và Deep Learning. Xây dựng mô hình AI giải quyết vấn đề thực tế.",
    icon: "ri-brain-line",
    color: "from-purple-500 to-pink-500",
    topics: [
      "Machine Learning",
      "Deep Learning",
      "Computer Vision",
      "Natural Language Processing",
    ],
  },
  {
    id: "4",
    title: "Công Nghệ Mới & Kỹ Năng Số",
    description:
      "Cloud Computing, DevOps, Blockchain và các công nghệ tiên tiến. Sẵn sàng cho tương lai.",
    icon: "ri-rocket-line",
    color: "from-orange-500 to-red-500",
    topics: [
      "AWS & Cloud",
      "Docker & Kubernetes",
      "Blockchain",
      "DevOps & CI/CD",
    ],
  },
];

export const problems: Problem[] = [
  {
    icon: "ri-book-line",
    text: "Học nhiều lý thuyết nhưng thiếu thực hành",
  },
  {
    icon: "ri-question-line",
    text: "Không biết bắt đầu từ đâu, lộ trình mơ hồ",
  },
  {
    icon: "ri-compass-line",
    text: "Thiếu định hướng nghề nghiệp rõ ràng",
  },
  {
    icon: "ri-briefcase-line",
    text: "Doanh nghiệp cần kỹ năng thực tế, không chỉ bằng cấp",
  },
];

export const solutions: Solution[] = [
  {
    icon: "ri-code-box-line",
    title: "Học Theo Dự Án Thật",
    description:
      "Mỗi khóa học đi kèm dự án thực tế từ doanh nghiệp. Bạn không chỉ học mà còn làm được.",
  },
  {
    icon: "ri-building-line",
    title: "Chương Trình Bám Sát Doanh Nghiệp",
    description:
      "Nội dung được thiết kế dựa trên nhu cầu tuyển dụng thực tế của các công ty công nghệ.",
  },
  {
    icon: "ri-road-map-line",
    title: "Lộ Trình Rõ Ràng",
    description:
      "Từ beginner đến kỹ sư, mỗi bước đều được định hướng cụ thể và đo lường được.",
  },
  {
    icon: "ri-user-star-line",
    title: "Mentors Đồng Hành",
    description:
      "Được hướng dẫn bởi senior developers và tech leads từ các công ty hàng đầu.",
  },
];

export const values: Value[] = [
  {
    icon: "ri-lightbulb-line",
    title: "Tư Duy Kỹ Sư",
    description:
      "Học cách tư duy như một kỹ sư thực thụ: phân tích vấn đề, thiết kế giải pháp, tối ưu hóa code.",
  },
  {
    icon: "ri-tools-line",
    title: "Kỹ Năng Thực Tế",
    description:
      "Làm chủ các công cụ và công nghệ đang được sử dụng rộng rãi trong ngành công nghiệp.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Tự Tin Ứng Tuyển",
    description:
      "Portfolio ấn tượng, kỹ năng phỏng vấn tốt, sẵn sàng cho bất kỳ vòng technical interview nào.",
  },
  {
    icon: "ri-team-line",
    title: "Sẵn Sàng Làm Việc",
    description:
      "Hiểu quy trình làm việc nhóm, Git workflow, Agile/Scrum và văn hóa công ty công nghệ.",
  },
];

export const audience: Audience[] = [
  {
    icon: "ri-graduation-cap-line",
    title: "Sinh Viên CNTT",
    description:
      "Bổ sung kiến thức thực tế, chuẩn bị tốt hơn cho thị trường lao động",
  },
  {
    icon: "ri-user-add-line",
    title: "Người Mới Ra Trường",
    description:
      "Nâng cấp kỹ năng, tăng cơ hội việc làm với mức lương hấp dẫn",
  },
  {
    icon: "ri-arrow-left-right-line",
    title: "Người Chuyển Ngành",
    description:
      "Bắt đầu sự nghiệp công nghệ từ con số 0 với lộ trình rõ ràng",
  },
  {
    icon: "ri-arrow-up-line",
    title: "Junior Developer",
    description:
      "Nâng cấp bản thân lên level tiếp theo, từ junior lên mid/senior",
  },
];

